import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import App from './components/App';
import './index.css';
import './assets/css/style.css';
import './assets/css/ReactToastify.css';
import './assets/css/satoshi.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
